'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FB = function FB(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: title, width: width, href: link, onClick: link ? undefined : _Actions2.default['facebook']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width }, props, { viewBox: '0 0 33 33' }),
      _react2.default.createElement(
        'title',
        null,
        title,
        ' button'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd', transform: 'translate(1 1)' },
        _react2.default.createElement('ellipse', { cx: '15.696', cy: '15.703', rx: '15.696', ry: '15.703' }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(11.631 8.727)' },
          _react2.default.createElement('path', { d: 'M2.138 14.483c0-.036.003-.071.003-.107V7.878H.093c-.091 0-.091 0-.091-.092 0-.8 0-1.601-.002-2.402 0-.073.021-.091.089-.091.654.003 1.307.002 1.96.002h.092v-.078c.002-.665-.003-1.331.006-1.997a3.766 3.766 0 0 1 .33-1.54c.304-.659.78-1.13 1.43-1.411A3.243 3.243 0 0 1 5.26 0c.536.009 1.07.034 1.606.054.1.004.198.021.298.027.055.003.074.024.074.082-.002.331-.001.663-.001.995 0 .39-.002.781.001 1.172 0 .068-.018.09-.084.089-.406-.003-.813-.008-1.219.001a2.783 2.783 0 0 0-.552.067c-.347.08-.553.32-.622.68a2.48 2.48 0 0 0-.045.443c-.006.542-.003 1.085-.002 1.627l.003.058h2.336c.098 0 .1 0 .087.097-.053.426-.108.853-.16 1.28-.044.356-.087.712-.128 1.069-.015.136-.012.137-.143.137H4.713v6.449l-.001.156H2.138z' })
        )
      )
    )
  );
};

FB.defaultProps = {
  title: "Share on Facebook"
};

exports.default = FB;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Facebook.js
// module id = 440
// module chunks = 168707334958949